export const TRANSLATIONS = {
      en: {
        "Accessibility Menu": "Accessibility Menu",
        "Reset settings": "Reset settings",
        "Reset All Settings": "Reset All Settings",
        "Close": "Close",
        "Content Adjustments": "Content Adjustments",
        "Adjust Font Size": "Adjust Font Size",
        "Highlight Title": "Highlight Title",
        "Highlight Links": "Highlight Links",
        "Readable Font": "Readable Font",
        "Color Adjustments": "Color Adjustments",
        "Invert Colors": "Invert Colors",
        "Light Contrast": "Light Contrast",
        "Dark Contrast": "Dark Contrast",
        "High Contrast": "High Contrast",
        "High Saturation": "High Saturation",
        "Low Saturation": "Low Saturation",
        "Monochrome": "Monochrome",
        "Tools": "Tools",
        "Reading Guide": "Reading Guide",
        "Stop Animations": "Stop Animations",
        "Big Cursor": "Big Cursor",
        "Increase Font Size": "Increase Font Size",
        "Decrease Font Size": "Decrease Font Size",
        "Letter Spacing": "Letter Spacing",
        "Line Height": "Line Height",
        "Font Weight": "Font Weight",
        "Dyslexia Font": "Dyslexia Font",
        "Language": "Language",
        "Open Accessibility Menu": "Open Accessibility Menu",
        "Hide Images": "Hide Images",
        "Skip to accessibility menu": "Skip to accessibility menu",
        "Accessibility Report": "Accessibility Report",
        "Run Accessibility Check": "Run Accessibility Check",
        "Loading...": "Loading...",
        "Analyzing page...": "Analyzing page...",
        "Critical": "Critical",
        "Serious": "Serious",
        "Moderate": "Moderate",
        "Minor": "Minor",
        "Violations Found": "Violations Found",
        "No Issues Found": "No Issues Found",
        "Element": "Element",
        "Issue": "Issue",
        "How to Fix": "How to Fix",
        "Close Report": "Close Report",
        "Passed Tests": "Passed Tests",
        "Items Need Review": "Items Need Review",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Text to Speech On",
        "Text to Speech Off": "Text to Speech Off",
        "Simplify Layout": "Simplify Layout",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Loading voice...": "Loading voice...",
        "Reading...": "Reading...",
      },
      it: {
        "Accessibility Menu": "Menu Accessibilità",
        "Reset settings": "Ripristina impostazioni",
        "Reset All Settings": "Ripristina tutte le impostazioni",
        "Close": "Chiudi",
        "Content Adjustments": "Regolazioni Contenuto",
        "Adjust Font Size": "Regola Dimensione Font",
        "Highlight Title": "Evidenzia Titoli",
        "Highlight Links": "Evidenzia Link",
        "Readable Font": "Font Leggibile",
        "Color Adjustments": "Regolazioni Colore",
        "Invert Colors": "Inverti Colori",
        "Light Contrast": "Contrasto Chiaro",
        "Dark Contrast": "Contrasto Scuro",
        "High Contrast": "Alto Contrasto",
        "High Saturation": "Alta Saturazione",
        "Low Saturation": "Bassa Saturazione",
        "Monochrome": "Monocromatico",
        "Tools": "Strumenti",
        "Reading Guide": "Guida di Lettura",
        "Stop Animations": "Ferma Animazioni",
        "Big Cursor": "Cursore Grande",
        "Increase Font Size": "Aumenta Dimensione Font",
        "Decrease Font Size": "Diminuisci Dimensione Font",
        "Letter Spacing": "Spaziatura Lettere",
        "Line Height": "Altezza Riga",
        "Font Weight": "Grassetto",
        "Dyslexia Font": "Font Dislessia",
        "Language": "Lingua",
        "Open Accessibility Menu": "Apri Menu Accessibilità",
        "Hide Images": "Nascondi Immagini",
        "Skip to accessibility menu": "Vai al menu accessibilità",
        "Accessibility Report": "Report Accessibilità",
        "Run Accessibility Check": "Esegui Controllo Accessibilità",
        "Loading...": "Caricamento...",
        "Analyzing page...": "Analisi pagina...",
        "Critical": "Critico",
        "Serious": "Grave",
        "Moderate": "Moderato",
        "Minor": "Minore",
        "Violations Found": "Violazioni Trovate",
        "No Issues Found": "Nessun Problema Trovato",
        "Element": "Elemento",
        "Issue": "Problema",
        "How to Fix": "Come Risolvere",
        "Close Report": "Chiudi Report",
        "Passed Tests": "Test Superati",
        "Items Need Review": "Elementi da Rivedere",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Sintesi Vocale Attiva",
        "Text to Speech Off": "Sintesi Vocale Disattiva",
        "Simplify Layout": "Simplify Layout",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Reading...": "Reading...",
      },
      fr: {
        "Accessibility Menu": "Menu Accessibilité",
        "Reset settings": "Réinitialiser les paramètres",
        "Reset All Settings": "Réinitialiser tous les paramètres",
        "Close": "Fermer",
        "Content Adjustments": "Ajustements du Contenu",
        "Adjust Font Size": "Ajuster la Taille de Police",
        "Highlight Title": "Surligner les Titres",
        "Highlight Links": "Surligner les Liens",
        "Readable Font": "Police Lisible",
        "Color Adjustments": "Ajustements des Couleurs",
        "Invert Colors": "Inverser les Couleurs",
        "Light Contrast": "Contraste Clair",
        "Dark Contrast": "Contraste Sombre",
        "High Contrast": "Contraste Élevé",
        "High Saturation": "Saturation Élevée",
        "Low Saturation": "Saturation Faible",
        "Monochrome": "Monochrome",
        "Tools": "Outils",
        "Reading Guide": "Guide de Lecture",
        "Stop Animations": "Arrêter les Animations",
        "Big Cursor": "Grand Curseur",
        "Increase Font Size": "Augmenter la Taille de Police",
        "Decrease Font Size": "Diminuer la Taille de Police",
        "Letter Spacing": "Espacement des Lettres",
        "Line Height": "Hauteur de Ligne",
        "Font Weight": "Graisse de Police",
        "Dyslexia Font": "Police Dyslexie",
        "Language": "Langue",
        "Open Accessibility Menu": "Ouvrir le Menu Accessibilité",
        "Hide Images": "Masquer les Images",
        "Skip to accessibility menu": "Aller au menu accessibilité",
        "Accessibility Report": "Rapport d'Accessibilité",
        "Run Accessibility Check": "Lancer le Contrôle d'Accessibilité",
        "Loading...": "Chargement...",
        "Analyzing page...": "Analyse de la page...",
        "Critical": "Critique",
        "Serious": "Grave",
        "Moderate": "Modéré",
        "Minor": "Mineur",
        "Violations Found": "Violations Trouvées",
        "No Issues Found": "Aucun Problème Trouvé",
        "Element": "Élément",
        "Issue": "Problème",
        "How to Fix": "Comment Corriger",
        "Close Report": "Fermer le Rapport",
        "Passed Tests": "Tests Réussis",
        "Items Need Review": "Éléments à Vérifier",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Synthèse Vocale Activée",
        "Text to Speech Off": "Synthèse Vocale Désactivée",
        "Simplify Layout": "Simplify Layout",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Reading...": "Reading...",
      },
      de: {
        "Accessibility Menu": "Barrierefreiheit-Menü",
        "Reset settings": "Einstellungen zurücksetzen",
        "Reset All Settings": "Alle Einstellungen zurücksetzen",
        "Close": "Schließen",
        "Content Adjustments": "Inhaltsanpassungen",
        "Adjust Font Size": "Schriftgröße anpassen",
        "Highlight Title": "Titel hervorheben",
        "Highlight Links": "Links hervorheben",
        "Readable Font": "Lesbare Schrift",
        "Color Adjustments": "Farbanpassungen",
        "Invert Colors": "Farben invertieren",
        "Light Contrast": "Heller Kontrast",
        "Dark Contrast": "Dunkler Kontrast",
        "High Contrast": "Hoher Kontrast",
        "High Saturation": "Hohe Sättigung",
        "Low Saturation": "Niedrige Sättigung",
        "Monochrome": "Monochrom",
        "Tools": "Werkzeuge",
        "Reading Guide": "Lesehilfe",
        "Stop Animations": "Animationen stoppen",
        "Big Cursor": "Großer Cursor",
        "Increase Font Size": "Schriftgröße erhöhen",
        "Decrease Font Size": "Schriftgröße verringern",
        "Letter Spacing": "Zeichenabstand",
        "Line Height": "Zeilenhöhe",
        "Font Weight": "Schriftstärke",
        "Dyslexia Font": "Legasthenie-Schrift",
        "Language": "Sprache",
        "Open Accessibility Menu": "Barrierefreiheit-Menü öffnen",
        "Hide Images": "Bilder ausblenden",
        "Skip to accessibility menu": "Zum Barrierefreiheit-Menü springen",
        "Accessibility Report": "Barrierefreiheit-Bericht",
        "Run Accessibility Check": "Barrierefreiheitsprüfung starten",
        "Loading...": "Laden...",
        "Analyzing page...": "Seite wird analysiert...",
        "Critical": "Kritisch",
        "Serious": "Schwerwiegend",
        "Moderate": "Mäßig",
        "Minor": "Gering",
        "Violations Found": "Verstöße gefunden",
        "No Issues Found": "Keine Probleme gefunden",
        "Element": "Element",
        "Issue": "Problem",
        "How to Fix": "Lösung",
        "Close Report": "Bericht schließen",
        "Passed Tests": "Bestandene Tests",
        "Items Need Review": "Elemente zur Überprüfung",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Sprachausgabe Ein",
        "Text to Speech Off": "Sprachausgabe Aus",
        "Simplify Layout": "Simplify Layout",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Reading...": "Reading...",
      },
      es: {
        "Accessibility Menu": "Menú de Accesibilidad",
        "Reset settings": "Restablecer configuración",
        "Reset All Settings": "Restablecer toda la configuración",
        "Close": "Cerrar",
        "Content Adjustments": "Ajustes de Contenido",
        "Adjust Font Size": "Ajustar Tamaño de Fuente",
        "Highlight Title": "Resaltar Títulos",
        "Highlight Links": "Resaltar Enlaces",
        "Readable Font": "Fuente Legible",
        "Color Adjustments": "Ajustes de Color",
        "Invert Colors": "Invertir Colores",
        "Light Contrast": "Contraste Claro",
        "Dark Contrast": "Contraste Oscuro",
        "High Contrast": "Alto Contraste",
        "High Saturation": "Alta Saturación",
        "Low Saturation": "Baja Saturación",
        "Monochrome": "Monocromo",
        "Tools": "Herramientas",
        "Reading Guide": "Guía de Lectura",
        "Stop Animations": "Detener Animaciones",
        "Big Cursor": "Cursor Grande",
        "Increase Font Size": "Aumentar Tamaño de Fuente",
        "Decrease Font Size": "Disminuir Tamaño de Fuente",
        "Letter Spacing": "Espaciado de Letras",
        "Line Height": "Altura de Línea",
        "Font Weight": "Grosor de Fuente",
        "Dyslexia Font": "Fuente para Dislexia",
        "Language": "Idioma",
        "Open Accessibility Menu": "Abrir Menú de Accesibilidad",
        "Hide Images": "Ocultar Imágenes",
        "Skip to accessibility menu": "Ir al menú de accesibilidad",
        "Accessibility Report": "Informe de Accesibilidad",
        "Run Accessibility Check": "Ejecutar Comprobación de Accesibilidad",
        "Loading...": "Cargando...",
        "Analyzing page...": "Analizando página...",
        "Critical": "Crítico",
        "Serious": "Grave",
        "Moderate": "Moderado",
        "Minor": "Menor",
        "Violations Found": "Violaciones Encontradas",
        "No Issues Found": "Sin Problemas Encontrados",
        "Element": "Elemento",
        "Issue": "Problema",
        "How to Fix": "Cómo Solucionarlo",
        "Close Report": "Cerrar Informe",
        "Passed Tests": "Pruebas Superadas",
        "Items Need Review": "Elementos a Revisar",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Texto a Voz Activado",
        "Text to Speech Off": "Texto a Voz Desactivado",
        "Simplify Layout": "Simplify Layout",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Reading...": "Reading...",
      },
      ru: {
        "Accessibility Menu": "Меню доступности",
        "Reset settings": "Сбросить настройки",
        "Reset All Settings": "Сбросить все настройки",
        "Close": "Закрыть",
        "Content Adjustments": "Настройки контента",
        "Adjust Font Size": "Изменить размер шрифта",
        "Highlight Title": "Выделить заголовки",
        "Highlight Links": "Выделить ссылки",
        "Readable Font": "Читаемый шрифт",
        "Color Adjustments": "Настройки цвета",
        "Invert Colors": "Инвертировать цвета",
        "Light Contrast": "Светлый контраст",
        "Dark Contrast": "Тёмный контраст",
        "High Contrast": "Высокий контраст",
        "High Saturation": "Высокая насыщенность",
        "Low Saturation": "Низкая насыщенность",
        "Monochrome": "Монохромный",
        "Tools": "Инструменты",
        "Reading Guide": "Линейка для чтения",
        "Stop Animations": "Остановить анимации",
        "Big Cursor": "Большой курсор",
        "Increase Font Size": "Увеличить размер шрифта",
        "Decrease Font Size": "Уменьшить размер шрифта",
        "Letter Spacing": "Межбуквенный интервал",
        "Line Height": "Высота строки",
        "Font Weight": "Жирный шрифт",
        "Dyslexia Font": "Шрифт для дислексии",
        "Language": "Язык",
        "Open Accessibility Menu": "Открыть меню доступности",
        "Hide Images": "Скрыть изображения",
        "Skip to accessibility menu": "Перейти к меню доступности",
        "Accessibility Report": "Отчёт о доступности",
        "Run Accessibility Check": "Запустить проверку доступности",
        "Loading...": "Загрузка...",
        "Analyzing page...": "Анализ страницы...",
        "Critical": "Критический",
        "Serious": "Серьёзный",
        "Moderate": "Умеренный",
        "Minor": "Незначительный",
        "Violations Found": "Найдены нарушения",
        "No Issues Found": "Проблем не найдено",
        "Element": "Элемент",
        "Issue": "Проблема",
        "How to Fix": "Как исправить",
        "Close Report": "Закрыть отчёт",
        "Passed Tests": "Пройденные тесты",
        "Items Need Review": "Требуют проверки",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Озвучивание Включено",
        "Text to Speech Off": "Озвучивание Выключено",
        "Simplify Layout": "Simplify Layout",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Reading...": "Reading...",
      },
      pl: {
        "Accessibility Menu": "Menu Dostępności",
        "Reset settings": "Zresetuj ustawienia",
        "Reset All Settings": "Zresetuj wszystkie ustawienia",
        "Close": "Zamknij",
        "Content Adjustments": "Dostosowanie Treści",
        "Adjust Font Size": "Dostosuj Rozmiar Czcionki",
        "Highlight Title": "Podświetl Tytuły",
        "Highlight Links": "Podświetl Linki",
        "Readable Font": "Czytelna Czcionka",
        "Color Adjustments": "Dostosowanie Kolorów",
        "Invert Colors": "Odwróć Kolory",
        "Light Contrast": "Jasny Kontrast",
        "Dark Contrast": "Ciemny Kontrast",
        "High Contrast": "Wysoki Kontrast",
        "High Saturation": "Wysoka Saturacja",
        "Low Saturation": "Niska Saturacja",
        "Monochrome": "Monochromatyczny",
        "Tools": "Narzędzia",
        "Reading Guide": "Linia do Czytania",
        "Stop Animations": "Zatrzymaj Animacje",
        "Big Cursor": "Duży Kursor",
        "Increase Font Size": "Zwiększ Rozmiar Czcionki",
        "Decrease Font Size": "Zmniejsz Rozmiar Czcionki",
        "Letter Spacing": "Odstępy Między Literami",
        "Line Height": "Wysokość Linii",
        "Font Weight": "Grubość Czcionki",
        "Dyslexia Font": "Czcionka dla Dysleksji",
        "Language": "Język",
        "Open Accessibility Menu": "Otwórz Menu Dostępności",
        "Hide Images": "Ukryj Obrazy",
        "Skip to accessibility menu": "Przejdź do menu dostępności",
        "Accessibility Report": "Raport Dostępności",
        "Run Accessibility Check": "Uruchom Sprawdzanie Dostępności",
        "Loading...": "Ładowanie...",
        "Analyzing page...": "Analizowanie strony...",
        "Critical": "Krytyczny",
        "Serious": "Poważny",
        "Moderate": "Umiarkowany",
        "Minor": "Drobny",
        "Violations Found": "Znalezione Naruszenia",
        "No Issues Found": "Brak Problemów",
        "Element": "Element",
        "Issue": "Problem",
        "How to Fix": "Jak Naprawić",
        "Close Report": "Zamknij Raport",
        "Passed Tests": "Zaliczone Testy",
        "Items Need Review": "Elementy do Sprawdzenia",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Czytanie Tekstu Włączone",
        "Text to Speech Off": "Czytanie Tekstu Wyłączone",
        "Simplify Layout": "Simplify Layout",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Reading...": "Reading...",
      },
      ro: {
        "Accessibility Menu": "Meniu Accesibilitate",
        "Reset settings": "Resetare setări",
        "Reset All Settings": "Resetare toate setările",
        "Close": "Închide",
        "Content Adjustments": "Ajustări Conținut",
        "Adjust Font Size": "Ajustare Dimensiune Font",
        "Highlight Title": "Evidențiere Titluri",
        "Highlight Links": "Evidențiere Linkuri",
        "Readable Font": "Font Lizibil",
        "Color Adjustments": "Ajustări Culoare",
        "Invert Colors": "Inversare Culori",
        "Light Contrast": "Contrast Luminos",
        "Dark Contrast": "Contrast Întunecat",
        "High Contrast": "Contrast Ridicat",
        "High Saturation": "Saturație Ridicată",
        "Low Saturation": "Saturație Scăzută",
        "Monochrome": "Monocrom",
        "Tools": "Instrumente",
        "Reading Guide": "Ghid de Citire",
        "Stop Animations": "Oprire Animații",
        "Big Cursor": "Cursor Mare",
        "Increase Font Size": "Mărire Dimensiune Font",
        "Decrease Font Size": "Micșorare Dimensiune Font",
        "Letter Spacing": "Spațiere Litere",
        "Line Height": "Înălțime Linie",
        "Font Weight": "Grosime Font",
        "Dyslexia Font": "Font pentru Dislexie",
        "Language": "Limbă",
        "Open Accessibility Menu": "Deschide Meniul Accesibilitate",
        "Hide Images": "Ascunde Imagini",
        "Skip to accessibility menu": "Salt la meniul de accesibilitate",
        "Accessibility Report": "Raport Accesibilitate",
        "Run Accessibility Check": "Rulează Verificare Accesibilitate",
        "Loading...": "Se încarcă...",
        "Analyzing page...": "Se analizează pagina...",
        "Critical": "Critic",
        "Serious": "Grav",
        "Moderate": "Moderat",
        "Minor": "Minor",
        "Violations Found": "Încălcări Găsite",
        "No Issues Found": "Nicio Problemă Găsită",
        "Element": "Element",
        "Issue": "Problemă",
        "How to Fix": "Cum se Remediază",
        "Close Report": "Închide Raportul",
        "Passed Tests": "Teste Trecute",
        "Items Need Review": "Elemente de Verificat",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Text to Speech Pornit",
        "Text to Speech Off": "Text to Speech Oprit",
        "Simplify Layout": "Simplify Layout",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Reading...": "Reading...",
      },
      nl: {
        "Accessibility Menu": "Toegankelijkheidsmenu",
        "Reset settings": "Instellingen resetten",
        "Reset All Settings": "Alle instellingen resetten",
        "Close": "Sluiten",
        "Content Adjustments": "Inhoudsaanpassingen",
        "Adjust Font Size": "Lettergrootte aanpassen",
        "Highlight Title": "Titels markeren",
        "Highlight Links": "Links markeren",
        "Readable Font": "Leesbaar Lettertype",
        "Color Adjustments": "Kleuraanpassingen",
        "Invert Colors": "Kleuren omkeren",
        "Light Contrast": "Licht Contrast",
        "Dark Contrast": "Donker Contrast",
        "High Contrast": "Hoog Contrast",
        "High Saturation": "Hoge Verzadiging",
        "Low Saturation": "Lage Verzadiging",
        "Monochrome": "Monochroom",
        "Tools": "Hulpmiddelen",
        "Reading Guide": "Leeshulp",
        "Stop Animations": "Animaties stoppen",
        "Big Cursor": "Grote Cursor",
        "Increase Font Size": "Lettergrootte vergroten",
        "Decrease Font Size": "Lettergrootte verkleinen",
        "Letter Spacing": "Letterafstand",
        "Line Height": "Regelhoogte",
        "Font Weight": "Letterdikte",
        "Dyslexia Font": "Dyslexie Lettertype",
        "Language": "Taal",
        "Open Accessibility Menu": "Toegankelijkheidsmenu openen",
        "Hide Images": "Afbeeldingen verbergen",
        "Skip to accessibility menu": "Ga naar toegankelijkheidsmenu",
        "Accessibility Report": "Toegankelijkheidsrapport",
        "Run Accessibility Check": "Toegankelijkheidscontrole uitvoeren",
        "Loading...": "Laden...",
        "Analyzing page...": "Pagina analyseren...",
        "Critical": "Kritiek",
        "Serious": "Ernstig",
        "Moderate": "Matig",
        "Minor": "Gering",
        "Violations Found": "Overtredingen Gevonden",
        "No Issues Found": "Geen Problemen Gevonden",
        "Element": "Element",
        "Issue": "Probleem",
        "How to Fix": "Hoe op te lossen",
        "Close Report": "Rapport Sluiten",
        "Passed Tests": "Geslaagde Tests",
        "Items Need Review": "Items te Controleren",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Tekst naar Spraak Aan",
        "Text to Speech Off": "Tekst naar Spraak Uit",
        "Simplify Layout": "Simplify Layout",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Reading...": "Reading...",
      },
      uk: {
        "Accessibility Menu": "Меню доступності",
        "Reset settings": "Скинути налаштування",
        "Reset All Settings": "Скинути всі налаштування",
        "Close": "Закрити",
        "Content Adjustments": "Налаштування контенту",
        "Adjust Font Size": "Змінити розмір шрифту",
        "Highlight Title": "Виділити заголовки",
        "Highlight Links": "Виділити посилання",
        "Readable Font": "Читабельний шрифт",
        "Color Adjustments": "Налаштування кольору",
        "Invert Colors": "Інвертувати кольори",
        "Light Contrast": "Світлий контраст",
        "Dark Contrast": "Темний контраст",
        "High Contrast": "Високий контраст",
        "High Saturation": "Висока насиченість",
        "Low Saturation": "Низька насиченість",
        "Monochrome": "Монохромний",
        "Tools": "Інструменти",
        "Reading Guide": "Лінійка для читання",
        "Stop Animations": "Зупинити анімації",
        "Big Cursor": "Великий курсор",
        "Increase Font Size": "Збільшити розмір шрифту",
        "Decrease Font Size": "Зменшити розмір шрифту",
        "Letter Spacing": "Міжлітерний інтервал",
        "Line Height": "Висота рядка",
        "Font Weight": "Жирний шрифт",
        "Dyslexia Font": "Шрифт для дислексії",
        "Language": "Мова",
        "Open Accessibility Menu": "Відкрити меню доступності",
        "Hide Images": "Приховати зображення",
        "Skip to accessibility menu": "Перейти до меню доступності",
        "Accessibility Report": "Звіт про доступність",
        "Run Accessibility Check": "Запустити перевірку доступності",
        "Loading...": "Завантаження...",
        "Analyzing page...": "Аналіз сторінки...",
        "Critical": "Критичний",
        "Serious": "Серйозний",
        "Moderate": "Помірний",
        "Minor": "Незначний",
        "Violations Found": "Знайдені порушення",
        "No Issues Found": "Проблем не знайдено",
        "Element": "Елемент",
        "Issue": "Проблема",
        "How to Fix": "Як виправити",
        "Close Report": "Закрити звіт",
        "Passed Tests": "Пройдені тести",
        "Items Need Review": "Потребують перевірки",
        "Annotations": "Annotations",
        "Text to Speech": "Text to Speech",
        "Text to Speech On": "Озвучування Увімкнено",
        "Text to Speech Off": "Озвучування Вимкнено",
        "Simplify Layout": "Simplify Layout",
        "Play": "Play",
        "Pause": "Pause",
        "Stop": "Stop",
        "Reading...": "Reading...",
      }
    };

export const SUPPORTED_LANGUAGES = [
      { code: "en", label: "English (English)" },
      { code: "it", label: "Italiano (Italian)" },
      { code: "fr", label: "Français (French)" },
      { code: "de", label: "Deutsch (German)" },
      { code: "es", label: "Español (Spanish)" },
      { code: "ru", label: "Русский (Russian)" },
      { code: "pl", label: "Polski (Polish)" },
      { code: "ro", label: "Română (Romanian)" },
      { code: "nl", label: "Nederlands (Dutch)" },
      { code: "uk", label: "Українська (Ukrainian)" }
    ];
